export class InvitadoJugadaGratis 
{
    public nombre: string;
    public mensaje: string;
    public movil: number;
}